import { graphql } from './__generated__';

/**
 * Вход сотрудника по email и паролю. Возвращает accessToken, а refresh-токен
 * бэкенд ставит httpOnly-кукой — клиент его не видит.
 */
export const LOGIN_MUTATION = graphql(`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      accessToken
    }
  }
`);

/** Новый accessToken по refresh-куке. Без живой куки — `UNAUTHENTICATED`. */
export const REFRESH_MUTATION = graphql(`
  mutation Refresh {
    refresh {
      accessToken
    }
  }
`);

/** Выход: бэкенд отзывает refresh-куку. Авторизации не требует. */
export const LOGOUT_MUTATION = graphql(`
  mutation Logout {
    logout
  }
`);

/** Текущий сотрудник по токену из куки. */
export const ME_QUERY = graphql(`
  query Me {
    me {
      uuid
      email
      lastName
      firstName
      middleName
      position {
        uuid
        code
        name
        modules {
          uuid
          code
          sortOrder
          isActive
        }
      }
    }
  }
`);

/** Модули системы — разделы кабинета, открытые сотруднику. */
export const MODULES_QUERY = graphql(`
  query Modules {
    modules {
      uuid
      code
      name
      sortOrder
      isActive
    }
  }
`);
